export type Team = {
  delete_on: string;
  delete_scheduled: boolean;
  exceeded_asset_threshold?: boolean;
  exceeded_bandwidth_threshold?: boolean;
  exceeded_storage_threshold?: boolean;
  has_subscription?: boolean;
  id: string;
  identifier: string;
  name: string;
  owner_delete_on: string;
  owner_delete_scheduled: boolean;
  subscription?: TeamSubscription;
}

export type TeamSubscription = {
  cancel: boolean;
  code: string;
  payment_method: string;
  plan: string;
}

export enum TeamPermissions {
  ADMIN = 'admin',
  MEMBER = 'member',
}

export enum TeamInviteType {
  INDIVIDUAL = 'individual',
  GROUP = 'group'
}

export type TeamInvite = {
  id: string;
  match: string;
  permissions: TeamPermissions.MEMBER | TeamPermissions.ADMIN;
  type: TeamInviteType.INDIVIDUAL | TeamInviteType.GROUP;
}